/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Carousel } from '@bingads-webui-react/primitive-unthemed';
import { getPreview } from './preview-factory';
import C from '../constants';
import { ImageExperienceVideo } from '../model/image-experience-video';
import { CustomThumbnailRecordType } from '../types';

export class VideoPreviewCarousel extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      index: 0,
      direction: null,
    };

    this.setupAdPreviewIndexToTitlesMap();
  }

  setPreviewIndexByType(videoType) {
    const currentIndex = C.videoPreviewsSettings.findIndex(s => s.videoType === videoType);

    if (currentIndex >= 0) {
      this.setState({
        index: currentIndex,
      });
    }
  }

  setupAdPreviewIndexToTitlesMap() {
    this.adPreviewIndexToTitle = [];

    const previewSettings = C.videoPreviewsSettings;
    const responsivePreviewsTitles = _.map(previewSettings, setting => this.props.i18n.getString(
      'ImageExperience_Ad_Preview_Title_Template',
      {
        // eslint-disable-next-line
          ratio: this.props.i18n.getString(setting.stringKey),
      }
    ));

    const genericTitle = this.props.i18n.getString('ImageExperience_Ad_Preview_Title');

    this.adPreviewIndexToTitle = this.adPreviewIndexToTitle.concat(responsivePreviewsTitles);
    this.adPreviewIndexToTitle.push(genericTitle);
  }

  getAdPreviewTitle() {
    const { index } = this.state;
    if (this.props.videoList.length > 0) {
      return this.adPreviewIndexToTitle[index];
    }
    return _.last(this.adPreviewIndexToTitle);
  }

  handleSelect = (selectedIndex, e) => {
    this.setState({
      index: selectedIndex,
      direction: e.direction,
    });
  }


  allVideosAreValid() {
    const allVideosValid = this.props.videoList.reduce((valid, vid) => valid && vid.status !== 'Failed', true);
    return this.props.videoList.length > 0 && allVideosValid;
  }


  render() {
    const { index, direction } = this.state;
    const {
      videoList,
      i18n,
      previewTexts,
      activityLogger,
    } = this.props;
    const items = [];

    const previewSettings = C.videoPreviewsSettings;
    _.each(previewSettings, (setting) => {
      const videoObj = videoList.find(v => v.Type === setting.videoType);
      if (videoObj) {
        items.push((
          <Carousel.Item key={setting.type}>
            {getPreview(
              videoObj,
              previewTexts,
              i18n,
              index === items.length,
              activityLogger,
              setting,
              this.props.customThumbnailRecord[C.videoTypeToThumbnailType[videoObj.Type]]
            )}
          </Carousel.Item>
        ));
      }
    });

    return (
      <div className="new-preview-carousel-container">
        <div className="ad-preview-title">
          {this.getAdPreviewTitle()}
        </div>
        {
          this.allVideosAreValid() &&
          <React.Fragment>
            <Carousel
              activeIndex={index}
              direction={direction}
              onSelect={this.handleSelect}
              controls={false}
              nextLabel={i18n.getString('ImageExperience_Ad_Preview_Next')}
              prevLabel={i18n.getString('ImageExperience_Ad_Preview_Previous')}
            >
              {items}
            </Carousel>
            <div className="disclaimer-info">
              <div className="disclaimer-info-inline">
                {i18n.getString('ImagePreview_Disclaimer_Message')}
              </div>
            </div>
          </React.Fragment>
        }
      </div>
    );
  }
}

VideoPreviewCarousel.propTypes = {
  videoList: PropTypes.arrayOf(PropTypes.instanceOf(ImageExperienceVideo)).isRequired,
  customThumbnailRecord: CustomThumbnailRecordType,
  previewTexts: PropTypes.shape({
    longHeadline: PropTypes.string,
    description: PropTypes.string,
    businessName: PropTypes.string,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }).isRequired,
  activityLogger: PropTypes.shape({
    signal: PropTypes.func.isRequired,
    error: PropTypes.func.isRequired,
  }),
};

VideoPreviewCarousel.defaultProps = {
  activityLogger: {
    signal: _.noop,
    error: _.noop,
  },
  customThumbnailRecord: {},
};
